<template>
  <div class="vz-warning-button">
    <vz-icon name="map-marker-alert" size="16" :variant="iconVariant" @click="showToast(true)" />
  </div>
</template>

<script setup lang="ts">
import {PropType} from 'vue';
import {ToastConfigureObject} from '~/types/types';

const emit = defineEmits(['update:hidden'])

const props = defineProps({
  toastData: {
    type: Array as PropType<ToastConfigureObject[]>,
    default: () => ([])
  },
  iconVariant: {
    type: String,
    default: 'primary'
  },
  hidden: {
    type: Boolean,
    default: false
  },
})

const {$showToast, $hideToast} = useNuxtApp()

// переделать на массив
const show = ref(false)
const localHidden = ref(false)
const toastInstance = ref(null as any)

const localToastData = computed(() => {
  return props.toastData.map((toast) => {
    return {
      ...toast,
      closeCB: () => closeCB(toast.closeCB),
      cancelCB: () => cancelCB(toast.cancelCB),
    }
  })
})

function showToast(force = false) {
  if (show.value || (localHidden.value && !force)) {
    return
  }

  show.value = true
  localToastData.value.forEach((toast) => toastInstance.value = $showToast(toast))
}

function hide() {
  $hideToast(toastInstance.value)
}

function updateHidden(value: boolean) {
  emit('update:hidden', value)
}

function closeCB(oldCB: Function) {
  show.value = false
  oldCB?.()
}

function cancelCB(oldCB: Function) {
  localHidden.value = true
  updateHidden(true)
  oldCB?.()
}

watch(() => props.hidden,
  () => {
    localHidden.value = props.hidden
  },
  { immediate: true }
)

defineExpose({showToast, hide})
</script>

<style lang="scss" scoped>
.vz-warning-button {
  display: inline;
  cursor: pointer;
}
</style>
